exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MyReflections-module__wrapper___1PQw-{display:grid;grid-template-columns:1fr;gap:1.5rem}@media screen and (min-width:525px){.MyReflections-module__wrapper___1PQw-{grid-template-columns:repeat(auto-fill,minmax(400px,1fr))}}.MyReflections-module__secondary-title___3VKwm{margin-top:2rem;margin-bottom:1rem}", ""]);

// exports
exports.locals = {
	"wrapper": "MyReflections-module__wrapper___1PQw-",
	"secondary-title": "MyReflections-module__secondary-title___3VKwm"
};